import React, { useMemo } from 'react';
import styled from 'styled-components';
import { isDedicated } from '../../../../../shared/styles';

const StyledHeader = styled.header`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 1rem 0 1rem;
`;

const StyledTitle = styled.h1`
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #232323;
`;

const StyledCloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  flex-shrink: 0;

  svg {
    width: 1rem;
    height: 1rem;
  }
`;

function CloseIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 1L1 13M1 1L13 13"
        stroke="#232323"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

type Props = {
  title: string;
  onClose?: () => void;
};

export function FlowHeader({ title, onClose }: Readonly<Props>) {
  const allowClose = useMemo(
    () =>
      !isDedicated(globalThis.xprops.renderAs) && typeof onClose === 'function',
    [onClose]
  );

  return (
    <StyledHeader>
      <StyledTitle>{title}</StyledTitle>
      {allowClose && (
        <StyledCloseButton onClick={onClose} aria-label="Close">
          <CloseIcon />
        </StyledCloseButton>
      )}
    </StyledHeader>
  );
}
